import { HTMLProps } from 'react';

import { ResourcePathArgs, useResourcePath } from '../../hooks/useResourcePath';
import { LinkableTableRow } from '../LinkableTableRow/LinkableTableRow';

export type ResourceTableRowProps = Omit<
  HTMLProps<HTMLTableRowElement>,
  keyof ResourcePathArgs
> &
  ResourcePathArgs;

export const ResourceTableRow = ({
  routeRef,
  name,
  children,
  params,
  transform,
  ...tableRowProps
}: ResourceTableRowProps) => {
  const path = useResourcePath({ routeRef, name, params, transform });

  return (
    <LinkableTableRow data-track-source-anchor="48c4f554e7;resource-table-row-linkable-table-row" {...tableRowProps} to={path || ''}>
      {children}
    </LinkableTableRow>
  );
};
